import React, {useEffect, useRef, useState} from 'react';
import {Button, Modal, Space, Spin, message} from 'antd';
import {FolderOpenOutlined, FolderViewOutlined} from '@ant-design/icons';
import {useGoogleDrivePicker} from '../helpers/googleDrive';
import useCurrentOrg from '../helpers/useCurrentOrg';
import {useAssetGroupState} from '../../contexts/AssetGroupContext';
import api from '../api';

export function GoogleDriveImportPicker({visible}) {
    const {currentUpload} = useAssetGroupState();
    const currentOrg = useCurrentOrg();
    const uploadId = currentUpload?.id;
    const latest = useRef();
    latest.current = {uploadId, orgId: currentOrg?.id};
    const {open, loading} = useGoogleDrivePicker({onPick: async (docs, orgId) => {
        if (latest.current.orgId !== orgId || latest.current.uploadId !== uploadId || !uploadId) return;
        const data = docs.map(({id, name, type}) => ({id, name, type}));
        await api.post('/api/ingestions', {ingestion: {data, upload_id: uploadId, type: 'GoogleDriveIngestion', notify: false}},
            {headers: {OrganizationId: orgId}});
        if (latest.current.orgId === orgId) message.success('Google Drive import started.');
    }});
    useEffect(() => { if (visible) open(); }, [visible]);
    return loading ? <Spin size="small"/> : null;
}

export function useGoogleDriveFolderPicker(onPick, modalTitle, chooseRootLabel) {
    const currentOrg = useCurrentOrg();
    const [modalVisible, setModalVisible] = useState(false);
    const {open: browse, cancel, loading} = useGoogleDrivePicker({foldersOnly: true, onPick: items => {
        setModalVisible(false);
        return onPick(items);
    }});
    useEffect(() => { setModalVisible(false); }, [currentOrg?.id]);
    const onCancel = () => { cancel(); setModalVisible(false); };
    const clickRoot = () => { cancel(); setModalVisible(false); onPick([{id: 'root'}]); };
    return {
        open: () => setModalVisible(true),
        modal: <Modal zIndex={2002} open={modalVisible} onCancel={onCancel} width="75%" footer={null}
            title={modalTitle || 'Select Folder To Download into on Google Drive'}>
            <Space>
                <Button onClick={clickRoot} icon={<FolderOpenOutlined/>}>{chooseRootLabel || 'Download To Root Folder'}</Button>
                <Button onClick={browse} loading={loading} icon={<FolderViewOutlined/>}>Choose Sub-Folder on Google Drive</Button>
            </Space>
        </Modal>
    };
}
